export default {
    cta: "Pergunte a um<br/>Consultor"
}